export const mockDramas = [
  {
    id: 'drama-001',
    slug: 'noor-dubai-love-ambition-story',
    genreSlug: 'romance-drama',
    title: 'Noor',
    description: 'A captivating story of love and ambition in modern Dubai, following a young woman\'s journey to success in the business world while navigating complex relationships.',
    synopsis: 'Noor is a compelling drama that follows the journey of a young Emirati woman navigating the complexities of modern Dubai. As she pursues her dreams in the competitive business world, she must balance traditional family expectations with her personal ambitions. The series explores themes of love, sacrifice, and the evolving role of women in contemporary Arab society.',
    poster: 'https://public.readdy.ai/ai/img_res/747a263121cd3d7da74c90065c44a669.jpg',
    banner: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20modern%20Dubai%20skyline%20at%20golden%20hour%20with%20elegant%20Middle%20Eastern%20woman%20silhouette%20professional%20drama%20series%20hero%20banner%20with%20warm%20lighting%20panoramic%20cityscape%20view&width=1200&height=400&seq=drama001banner&orientation=landscape',
    rating: 4.8,
    episodes: 12,
    year: 2024,
    genre: ['Romance', 'Drama'],
    views: '2.3M',
    status: 'completed',
    country: 'UAE',
    language: 'Arabic',
    director: 'Ahmed Al-Mansouri',
    cast: ['Layla Hassan', 'Omar Khalil', 'Fatima Al-Zahra', 'Saeed Al-Maktoum'],
    duration: '45 min',
    releaseDate: '2024-01-15',
    tags: ['love', 'business', 'dubai', 'modern', 'family', 'success']
  },
  {
    id: 'drama-002',
    slug: 'desert-winds-arabian-family-saga',
    genreSlug: 'drama-thriller',
    title: 'Desert Winds',
    description: 'An epic tale of family honor and betrayal in the Arabian desert, spanning three generations of a Bedouin family fighting to preserve their traditions.',
    synopsis: 'Desert Winds chronicles the struggles of the Al-Rashid family across three generations as they navigate the changing landscape of the Arabian Peninsula. From the pearl diving era to the oil boom, this sweeping saga explores themes of honor, loyalty, and the clash between tradition and modernity.',
    poster: 'https://readdy.ai/api/search-image?query=Dramatic%20Arabian%20desert%20landscape%20with%20traditional%20Middle%20Eastern%20architecture%20cinematic%20poster%20style%20with%20golden%20sunset%20lighting%20and%20majestic%20sand%20dunes%20epic%20drama%20series%20promotional%20image&width=300&height=400&seq=drama002&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20Arabian%20desert%20panorama%20at%20sunset%20with%20Bedouin%20camp%20silhouettes%20dramatic%20cinematic%20banner%20with%20warm%20amber%20tones%20and%20vast%20sand%20dunes%20professional%20production&width=1200&height=400&seq=drama002banner&orientation=landscape',
    rating: 4.6,
    episodes: 8,
    year: 2024,
    genre: ['Drama', 'Thriller'],
    views: '1.8M',
    status: 'completed',
    country: 'Saudi Arabia',
    language: 'Arabic',
    director: 'Khalid Al-Rashid',
    cast: ['Mohammed Bin Rashid', 'Aisha Al-Fahad', 'Saad Al-Otaibi'],
    duration: '50 min',
    releaseDate: '2024-02-20',
    tags: ['family', 'tradition', 'desert', 'honor', 'generations']
  },
  {
    id: 'drama-003',
    slug: 'city-of-dreams-cairo-entrepreneurs',
    genreSlug: 'drama-business',
    title: 'City of Dreams',
    description: 'Young entrepreneurs chase success in bustling Cairo, navigating the challenges of startup culture while dealing with personal relationships and family expectations.',
    synopsis: 'City of Dreams follows a group of ambitious young Egyptians as they launch a tech startup in Cairo. The series explores the vibrant entrepreneurial scene of modern Egypt while delving into the personal struggles of balancing career ambitions with family obligations and romantic relationships.',
    poster: 'https://readdy.ai/api/search-image?query=Modern%20Cairo%20cityscape%20with%20young%20Middle%20Eastern%20professionals%20contemporary%20drama%20poster%20style%20with%20vibrant%20city%20lights%20and%20urban%20energy%20business%20drama%20series%20promotional%20image&width=300&height=400&seq=drama003&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Panoramic%20Cairo%20skyline%20at%20night%20with%20modern%20buildings%20and%20Nile%20River%20contemporary%20urban%20drama%20banner%20with%20city%20lights%20and%20professional%20atmosphere&width=1200&height=400&seq=drama003banner&orientation=landscape',
    rating: 4.7,
    episodes: 10,
    year: 2024,
    genre: ['Drama', 'Business'],
    views: '1.5M',
    status: 'ongoing',
    country: 'Egypt',
    language: 'Arabic',
    director: 'Yasmin Farouk',
    cast: ['Ahmed Ezz', 'Menna Shalabi', 'Karim Kassem'],
    duration: '40 min',
    releaseDate: '2024-03-10',
    tags: ['startup', 'cairo', 'youth', 'dreams', 'technology']
  },
  {
    id: 'drama-004',
    slug: 'the-last-garden-lebanese-family-heritage',
    genreSlug: 'family-drama',
    title: 'The Last Garden',
    description: 'A family fights to preserve their ancestral home and garden against modern development, exploring themes of heritage, memory, and the clash between old and new.',
    synopsis: 'The Last Garden tells the story of the Khoury family as they struggle to save their century-old family estate from developers. Set in the Lebanese mountains, this intimate drama explores generational conflicts, the weight of family legacy, and the meaning of home in a rapidly changing world.',
    poster: 'https://readdy.ai/api/search-image?query=Beautiful%20traditional%20Middle%20Eastern%20garden%20with%20ancient%20architecture%20family%20drama%20poster%20style%20with%20lush%20greenery%20and%20historical%20elements%20heritage%20drama%20series%20promotional%20image&width=300&height=400&seq=drama004&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Stunning%20Lebanese%20mountain%20landscape%20with%20traditional%20stone%20house%20and%20terraced%20gardens%20cinematic%20banner%20with%20warm%20natural%20lighting%20and%20heritage%20atmosphere&width=1200&height=400&seq=drama004banner&orientation=landscape',
    rating: 4.5,
    episodes: 6,
    year: 2023,
    genre: ['Family', 'Drama'],
    views: '1.2M',
    status: 'completed',
    country: 'Lebanon',
    language: 'Arabic',
    director: 'Rima Fakih',
    cast: ['Nadine Nassib', 'Wael Kfoury', 'Carmen Lebbos'],
    duration: '35 min',
    releaseDate: '2023-11-05',
    tags: ['heritage', 'family', 'tradition', 'garden', 'legacy']
  },
  {
    id: 'drama-005',
    slug: 'midnight-in-amman-psychological-thriller',
    genreSlug: 'thriller-mystery',
    title: 'Midnight in Amman',
    description: 'A psychological thriller following a detective investigating mysterious disappearances in the ancient streets of Amman, uncovering dark secrets from the past.',
    synopsis: 'Detective Tariq Mansour is assigned to investigate a series of disappearances in Amman\'s old city. As he delves deeper into the case, he uncovers a web of secrets connecting the city\'s past to its present. This gripping thriller combines mystery with social commentary on modern Jordanian society.',
    poster: 'https://readdy.ai/api/search-image?query=Mysterious%20nighttime%20Amman%20cityscape%20with%20ancient%20Roman%20ruins%20thriller%20poster%20style%20with%20dramatic%20shadows%20and%20moonlight%20psychological%20drama%20series%20promotional%20image&width=300&height=400&seq=drama005&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Atmospheric%20night%20view%20of%20Amman%20with%20ancient%20citadel%20and%20modern%20city%20lights%20noir%20thriller%20banner%20with%20dramatic%20shadows%20and%20mysterious%20atmosphere&width=1200&height=400&seq=drama005banner&orientation=landscape',
    rating: 4.4,
    episodes: 8,
    year: 2024,
    genre: ['Thriller', 'Mystery'],
    views: '980K',
    status: 'ongoing',
    country: 'Jordan',
    language: 'Arabic',
    director: 'Samer Al-Khatib',
    cast: ['Eyad Nassar', 'Saba Mubarak', 'Iyad Hajjaj'],
    duration: '42 min',
    releaseDate: '2024-04-01',
    tags: ['mystery', 'detective', 'amman', 'thriller', 'secrets']
  },
  {
    id: 'drama-006',
    slug: 'pearl-divers-kuwait-historical-drama',
    genreSlug: 'historical-drama',
    title: 'Pearl Divers',
    description: 'Set in 1950s Kuwait, this historical drama follows pearl divers and their families as they face the changing times with the discovery of oil.',
    synopsis: 'Pearl Divers transports viewers to 1950s Kuwait during the twilight of the pearl diving industry. The series follows the Al-Sabah family of pearl divers as they witness the transformation of their society with the discovery of oil, exploring themes of tradition, change, and the human cost of progress.',
    poster: 'https://readdy.ai/api/search-image?query=Historical%20Kuwait%20pearl%20diving%20scene%20with%20traditional%20dhow%20boats%20period%20drama%20poster%20style%20with%20sepia%20tones%20and%20vintage%20maritime%20atmosphere%20cultural%20heritage%20series%20promotional%20image&width=300&height=400&seq=drama006&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Vintage%20Arabian%20Gulf%20seascape%20with%20traditional%20pearl%20diving%20boats%20at%20sunrise%20historical%20drama%20banner%20with%20warm%20golden%20tones%20and%20maritime%20heritage%20atmosphere&width=1200&height=400&seq=drama006banner&orientation=landscape',
    rating: 4.6,
    episodes: 10,
    year: 2023,
    genre: ['Historical', 'Drama'],
    views: '1.1M',
    status: 'completed',
    country: 'Kuwait',
    language: 'Arabic',
    director: 'Bader Al-Shuaibi',
    cast: ['Abdulhussain Abdulredha', 'Souad Abdullah', 'Dawood Hussein'],
    duration: '48 min',
    releaseDate: '2023-09-15',
    tags: ['historical', 'kuwait', 'pearls', 'tradition', 'oil']
  },
  {
    id: 'drama-007',
    slug: 'doha-nights-qatar-romantic-comedy',
    genreSlug: 'romance-comedy',
    title: 'Doha Nights',
    description: 'A romantic comedy series about young professionals in modern Doha, exploring love, friendship, and career ambitions in Qatar\'s rapidly changing society.',
    synopsis: 'Doha Nights is a lighthearted romantic comedy following a group of friends navigating love and career in modern Qatar. The series offers a fresh perspective on Gulf society, blending humor with heartfelt moments as characters balance traditional expectations with contemporary aspirations.',
    poster: 'https://readdy.ai/api/search-image?query=Modern%20Doha%20skyline%20at%20night%20with%20young%20Middle%20Eastern%20couples%20romantic%20comedy%20poster%20style%20with%20warm%20city%20lights%20and%20contemporary%20architecture%20feel-good%20series%20promotional%20image&width=300&height=400&seq=drama007&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Stunning%20Doha%20waterfront%20at%20twilight%20with%20modern%20skyscrapers%20and%20traditional%20dhow%20boats%20romantic%20comedy%20banner%20with%20vibrant%20colors%20and%20contemporary%20atmosphere&width=1200&height=400&seq=drama007banner&orientation=landscape',
    rating: 4.3,
    episodes: 12,
    year: 2024,
    genre: ['Romance', 'Comedy'],
    views: '850K',
    status: 'upcoming',
    country: 'Qatar',
    language: 'Arabic',
    director: 'Nora Al-Thani',
    cast: ['Fahad Al-Kubaisi', 'Amal Al-Mannai', 'Jassim Al-Nabhan'],
    duration: '38 min',
    releaseDate: '2024-06-01',
    tags: ['romance', 'comedy', 'doha', 'modern', 'friendship']
  },
  {
    id: 'drama-008',
    slug: 'merchants-daughter-damascus-period-drama',
    genreSlug: 'historical-drama',
    title: "The Merchant's Daughter",
    description: 'A period drama set in 19th century Damascus, following a merchant\'s daughter who challenges social norms to pursue her dreams of becoming a scholar.',
    synopsis: 'Set in the vibrant souks of 19th century Damascus, The Merchant\'s Daughter tells the story of Layla, a young woman who defies convention to pursue education and independence. The series offers a rich portrayal of Ottoman-era Syria while exploring timeless themes of ambition, love, and social change.',
    poster: 'https://readdy.ai/api/search-image?query=Historical%20Damascus%20marketplace%20with%20traditional%20Middle%20Eastern%20woman%20in%20period%20costume%20period%20drama%20poster%20style%20with%20rich%20textures%20and%20authentic%20historical%20atmosphere%20cultural%20drama%20series%20promotional%20image&width=300&height=400&seq=drama008&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Atmospheric%20view%20of%20historic%20Damascus%20souk%20with%20traditional%20architecture%20and%20merchants%20period%20drama%20banner%20with%20warm%20amber%20lighting%20and%20authentic%20Middle%20Eastern%20atmosphere&width=1200&height=400&seq=drama008banner&orientation=landscape',
    rating: 4.7,
    episodes: 8,
    year: 2023,
    genre: ['Historical', 'Drama'],
    views: '1.3M',
    status: 'completed',
    country: 'Syria',
    language: 'Arabic',
    director: 'Hatem Ali',
    cast: ['Kinda Alloush', 'Qasem Malho', 'Salim Sabri'],
    duration: '45 min',
    releaseDate: '2023-10-20',
    tags: ['historical', 'damascus', 'education', 'women', 'ottoman']
  }
];

export const dramaGenres = ['Romance', 'Drama', 'Thriller', 'Comedy', 'Action', 'Historical', 'Family', 'Business', 'Mystery'];
export const dramaCountries = ['UAE', 'Saudi Arabia', 'Egypt', 'Lebanon', 'Jordan', 'Kuwait', 'Qatar', 'Syria'];
export const dramaStatuses = ['ongoing', 'completed', 'upcoming'];

export const getDramaBySlug = (slug: string) => {
  return mockDramas.find(d => d.slug === slug || d.id === slug);
};

export const getDramaById = (id: string) => {
  return mockDramas.find(d => d.id === id);
};

// New helper function to get drama by full slug (genreSlug-titleSlug)
export const getDramaByFullSlug = (fullSlug: string) => {
  // Try to match the full slug format: genreSlug-titleSlug
  return mockDramas.find(d => {
    const expectedFullSlug = `${d.genreSlug}-${d.slug}`;
    return expectedFullSlug === fullSlug;
  }) || mockDramas.find(d => d.slug === fullSlug || d.id === fullSlug); // Fallback for backward compatibility
};

export const getDramasByGenre = (genre: string) => {
  return mockDramas.filter(d => d.genre.includes(genre));
};

export const getDramasByCountry = (country: string) => {
  return mockDramas.filter(d => d.country === country);
};

export const getRelatedDramas = (dramaId: string, limit: number = 3) => {
  const drama = getDramaById(dramaId);
  if (!drama) return [];
  return mockDramas
    .filter(d => d.id !== dramaId && d.genre.some(g => drama.genre.includes(g)))
    .slice(0, limit);
};
